import { render, staticRenderFns } from "./BB-sorting.vue?vue&type=template&id=5c91b2c8&scoped=true&"
import script from "./BB-sorting.vue?vue&type=script&lang=js&"
export * from "./BB-sorting.vue?vue&type=script&lang=js&"
import style0 from "./BB-sorting.vue?vue&type=style&index=0&id=5c91b2c8&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91b2c8",
  null
  
)

export default component.exports